var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-86aece32-adce-4dfd-8523-442f07925fc8",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-553886e8-8557-495e-bfd8-d4652af6ad9f {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-553886e8-8557-495e-bfd8-d4652af6ad9f",
    d: "M18.19,10.6l-4.86-2.75.02,1.79c-1.65.67-2.98,1.96-3.69,3.61-1.02,2.37-.7,4.84.91,6.95.2.26.49.39.8.39.21,0,.42-.07.61-.21.44-.33.52-.96.19-1.4-1.48-1.94-1.18-3.76-.67-4.95.39-.91,1.06-1.65,1.88-2.16v1.56s4.82-2.84,4.82-2.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-553886e8-8557-495e-bfd8-d4652af6ad9f",
    d: "M21.43,11.8c-.33-.44-.96-.52-1.4-.19-.44.33-.52.96-.19,1.4,1.48,1.94,1.18,3.76.67,4.95-.39.91-1.06,1.65-1.88,2.16v-1.56s-4.82,2.84-4.82,2.84l4.86,2.75-.02-1.79c1.65-.67,2.98-1.96,3.69-3.61,1.02-2.37.7-4.84-.91-6.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.c706be7d8a280afd91052ca85e824725.svg";
export { ForwardRef as ReactComponent };